module.exports = __webpack_public_path__ + "static/media/4.b37c6b2d.svg";